import { useQuery } from 'query';
import { loadFR } from 'scenes/FinancePage/FR/sources';

import { details } from './queryKeyFactory';

export const useLoadFR = ({ id }: { id: number }) => {
  return useQuery(details({ id }), async () => {
    return loadFR({ id });
  });
};
